import React from 'react';
import ShareableLinksEmpty from '../ShareableLinksEmpty';
import ShareableLinksMobile from '../ShareableLinksMobile';
import ShareableLinksTable from '../ShareableLinksTable';
import useMatchMedia from 'hooks/useMatchMedia';
import { DataRoomShareableLink } from 'models/ShareableLink';

type ShareableLinkContentProps = {
  isLoading: boolean;
  isEmpty: boolean;
  totalPages: number;
  totalItems?: number;
  shareableLinks: DataRoomShareableLink[];
  isActive: boolean;
  updateShareableLink: (shareableLink: DataRoomShareableLink) => void;
  onAfterToggleState?: (linkBeforeToggle: DataRoomShareableLink) => void;
};

const ShareableLinkContent: React.FC<ShareableLinkContentProps> = (props) => {
  const {
    isLoading,
    isEmpty,
    totalPages,
    totalItems,
    shareableLinks,
    isActive,
    updateShareableLink,
    onAfterToggleState,
  } = props;

  const isPhablet = useMatchMedia('isPhablet');

  return (
    <>
      {!isLoading && isEmpty ? (
        <ShareableLinksEmpty isActive={isActive} />
      ) : isPhablet ? (
        <ShareableLinksMobile
          isLoading={isLoading}
          totalPages={totalPages}
          shareableLinks={shareableLinks}
          updateShareableLink={updateShareableLink}
          onAfterToggleState={onAfterToggleState}
        />
      ) : (
        <ShareableLinksTable
          isLoading={isLoading}
          totalPages={totalPages}
          totalItems={totalItems}
          shareableLinks={shareableLinks}
          updateShareableLink={updateShareableLink}
          onAfterToggleState={onAfterToggleState}
        />
      )}
    </>
  );
};

export default ShareableLinkContent;
